import React, { useEffect, useMemo, useState } from 'react';
import ServiceRequestStep from './ServiceRequestStep';
import _ from 'lodash';
import Button from '../../components/form-elements/Button';

function ServiceRequestStepper({ steps, onStepperSubmit }) {
    const [activeStep, setActiveStep] = useState(0);
    const [listOfStepValues, setStepValues] = useState([]);

    const getCurrentStatusFromIndex = index => {
        if (activeStep === index) return 'active';
        else if (!_.isNil(listOfStepValues[index])) return 'done';
        else return 'incomplete';
    };

    useEffect(() => {
        let nextIncompleteIndex = listOfStepValues.length;
        setActiveStep(nextIncompleteIndex);
    }, [listOfStepValues]);

    const isLastStep = useMemo(() => {
        return steps.length === listOfStepValues.length;
    }, [listOfStepValues.length, steps.length]);

    const handleStepSubmit = (values, actions, index) => {
        actions.setSubmitting(false);
        setStepValues(previousStepValues => {
            const newStepValues = [...previousStepValues];
            newStepValues.splice(index, 1, values);
            return newStepValues;
        });
    };

    return (
        <>
            {steps.map((step, index) => {
                const stepValues = listOfStepValues[index];
                const currentStepValues = _.isEmpty(stepValues) ? step.initialValues : stepValues;
                const status = getCurrentStatusFromIndex(index);
                return (
                    <ServiceRequestStep
                        key={index}
                        step={step}
                        stepNumber={index + 1}
                        status={status}
                        onStepSubmit={(newStepValues, actions) => handleStepSubmit(newStepValues, actions, index)}
                        onGoToStep={evt => {
                            evt.preventDefault();
                            setActiveStep(index);
                        }}
                        values={currentStepValues}
                    />
                );
            })}
            {isLastStep && (
                <div className="uk-grid-small uk-grid" data-uk-grid="">
                    <div className="uk-width-auto">
                        <span className="uk-badge uk-invisible">{steps.length + 1}</span>
                    </div>
                    <div className="uk-width-expand">
                        <Button modifier="secondary" fullWidth onClick={() => onStepperSubmit(Object.assign({}, ...listOfStepValues))}>
                            ANFRAGE ABSENDEN
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
}

export default ServiceRequestStepper;
